import { LinearProgress } from '@mui/material';

export function MainFallback() {
  return <LinearProgress variant="indeterminate" />;
}
